<template>
  <el-input
    class="kye-date-editor3 el-date-editor"
    :class="['el-date-editor--' + type, isMultiple && 'multiple']"
    :readonly="!editable || readonly || type === 'dates' || type === 'months'"
    :disabled="pickerDisabled"
    :size="pickerSize"
    :name="name"
    v-bind="firstInputId"
    v-if="!ranged"
    v-clickoutside="handleClose"
    :placeholder="currentPlaceholder"
    @focus="handleFocus"
    @keydown.native="handleKeydown"
    :value="isMultiple ? '' : templateDisplayValue"
    @input="value => (userInput = value)"
    @change="handleChange"
    @mouseenter.native="handleMouseEnter"
    @mouseleave.native="showClose = false"
    :validateEvent="false"
    ref="reference">
    <div slot="prefix" v-if="isMultiple && multipInputPrefixConfig.lastDate" class="months-prefix-wrap">
      <div class="flex" @click="handleFocus">
        <span class="el-tag el-tag--info el-tag--mini">
          <span class="el-select__tags-text">{{ multipInputPrefixConfig.lastDate }}</span>
          <i style="font-size: 16px" class="el-tag__close el-icon-close" @click.stop="handleDeleteDates"></i>
        </span>
        <span
          @mouseenter="handleMouseEnterMultipleTag"
          @mouseleave="handleMouseLeaveMultipleTag"
          class="el-tag el-tag--info el-tag--mini ml-6"
          v-if="multipInputPrefixConfig.leng > 1">
          <span class="el-select__tags-text kye-date3-tags-text">+{{ multipInputPrefixConfig.num }}</span>
        </span>
        <el-popover
          popper-class="kye-date3-multiple-wrap-popper"
          ref="multiplePopover"
          :width="popoverTagWidth"
          trigger="hover"
          placement="bottom-start">
          <div class="kye-date3-multiple-wrap">
            <div class="kye-date3-multiple-wrap-item" v-for="date in multipInputPrefixConfig.data" :key="date">{{ date }}</div>
          </div>
        </el-popover>
      </div>
    </div>
    <i v-else slot="prefix" class="el-input__icon" :class="triggerClass" @click="handleFocus"> </i>
    <i
      slot="suffix"
      style="font-size: 12px; color: #888b92"
      :class="[showClose ? '' + clearIcon : 'layout layout-calendar']"
      @click="handleClickIcon"
      v-if="haveTrigger"></i>
  </el-input>
  <div
    class="kye-date-editor3 el-date-editor el-range-editor el-input__inner"
    :class="[
      'el-date-editor--' + type,
      pickerSize ? `el-range-editor--${pickerSize}` : '',
      pickerDisabled ? 'is-disabled' : '',
      pickerVisible ? 'is-active' : ''
    ]"
    @click="handleRangeClick"
    @mouseenter="handleMouseEnter"
    @mouseleave="showClose = false"
    @keydown="handleKeydown"
    ref="reference"
    v-clickoutside="handleClose"
    v-else>
    <!-- <i :class="['el-input__icon', 'el-range__icon', triggerClass]"></i> -->
    <div class="kye-date-editor3-input-wrap">
      <input
        autocomplete="off"
        :placeholder="currentPlaceholder && currentPlaceholder[0]"
        :value="templateDisplayValue && templateDisplayValue[0]"
        :disabled="leftDisabled || pickerDisabled"
        v-bind="firstInputId"
        :readonly="!editable || readonly"
        :name="name && name[0]"
        @input="handleStartInput"
        @change="handleStartChange"
        @focus="handleFocus($event, 0, true)"
        :class="[
          startInputBgVisible ? 'is-bg' : ''
        ]"
        class="el-range-input is-start" />
      <!-- TODO 增加单边的清除按钮 -->
      <!-- <i class="el-input__icon el-icon-circle-close el-input__clear" style="line-height: 1;"></i> -->
      <span class="el-range-separator">{{ rangeSeparator }}</span>
      <input
        autocomplete="off"
        :placeholder="currentPlaceholder && currentPlaceholder[1]"
        :value="templateDisplayValue && templateDisplayValue[1]"
        :disabled="rightDisabled || pickerDisabled"
        v-bind="secondInputId"
        :readonly="!editable || readonly"
        :name="name && name[1]"
        @input="handleEndInput"
        @change="handleEndChange"
        @focus="handleFocus($event, 1, true)"
        :class="[
          endInputBgVisible ? 'is-bg' : ''
        ]"
        class="el-range-input is-end" />
      <!-- TODO 增加单边的清除按钮 -->
      <!-- <i class="el-input__icon el-icon-circle-close el-input__clear" style="line-height: 1;"></i> -->
    </div>
    <!-- <i
      @click="handleClickIcon"
      v-if="haveTrigger"
      :class="[showClose ? '' + clearIcon : '']"
      class="el-input__icon el-range__close-icon">
    </i> -->
    <div class="kye-date-editor3-icon-wrap">
      <i
        @click="handleClickIcon"
        v-if="haveTrigger && clearable"
        :class="[showClose ? '' + clearIcon : '']"
        class="el-input__icon close-icon">
      </i>
      <i slot="suffix" style="color: #888b92;font-size:12px;" :class="[dateHasTime ? 'layout layout-time' : 'icon-date']" v-if="!showClose">
      </i>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import {
  formatDate,
  parseDate,
  isDateObject,
  getWeekNumber,
  tailWeekCheck,
  dateFormatCallback,
  isDate,
  correctDatesOrder
} from './util'
import Popper from 'element-ui/lib/utils/vue-popper'
import Emitter from 'element-ui/lib/mixins/emitter'
import merge from 'element-ui/lib/utils/merge'
import moment from 'moment'
import { time } from '@/public/utils'
import { PopupManager } from 'element-ui/lib/utils/popup'
import './style/picker.scss'
export const FORMAT = (val, fmt) => {
  // 类型为datas，val是数组
  if (fmt === 'timestamp' || Array.isArray(val)) {
    return val
  } else {
    return time(val, fmt.replace(/y/g, 'Y').replace(/d/g, 'D'))
  }
}

const NewPopper = {
  props: {
    appendToBody: Popper.props.appendToBody,
    offset: Popper.props.offset,
    boundariesPadding: Popper.props.boundariesPadding,
    arrowOffset: Popper.props.arrowOffset
  },
  methods: Popper.methods,
  data() {
    return merge({ visibleArrow: true }, Popper.data)
  },
  beforeDestroy: Popper.beforeDestroy
}

const DEFAULT_FORMATS = {
  date: 'yyyy-MM-dd',
  month: 'yyyy-MM',
  months: 'yyyy-MM',
  datetime: 'yyyy-MM-dd HH:mm:ss',
  time: 'HH:mm:ss',
  week: 'yyyywWW',
  timerange: 'HH:mm:ss',
  daterange: 'yyyy-MM-dd',
  weekrange: 'yyyywWW',
  monthrange: 'yyyy-MM',
  datetimerange: 'yyyy-MM-dd HH:mm:ss',
  year: 'yyyy'
}

const MOMENT_FORMAT = {
  'yyyy-MM-dd': 'YYYY-MM-DD',
  'yyyy-MM': 'YYYY-MM',
  'yyyy-MM-dd HH:mm:ss': 'YYYY-MM-DD HH:mm:ss',
  'HH:mm:ss': 'HH:mm:ss',
  'yyyywWW': 'YYYY-MM-DD HH:mm:ss',
  'yyyy': 'YYYY',
  'yyyy-MM-dd HH:mm': 'YYYY-MM-DD HH:mm',
  'MM-dd': 'MM-DD',
  'HH:mm': 'HH:mm'
}

const HAVE_TRIGGER_TYPES = [
  'date',
  'datetime',
  'time',
  'time-select',
  'week',
  'month',
  'year',
  'daterange',
  'weekrange',
  'monthrange',
  'timerange',
  'datetimerange',
  'dates',
  'months'
]
const DATE_FORMATTER = function (value, format) {
  if (format === 'timestamp') return value.getTime()
  return formatDate(value, format)
}
const DATE_PARSER = function (text, format) {
  // try {
  //   if (format === 'timestamp') return new Date(Number(text))
  //   if (typeof text === 'number') {
  //     return moment(moment(text).format(MOMENT_FORMAT[format])).toDate()
  //   }
  //   const date = parseDate(text, format)
  //   return date || moment(text, MOMENT_FORMAT[format || 'yyyy-MM-dd']).toDate()
  // } catch (error) {
  //   return moment(text, MOMENT_FORMAT[format || 'yyyy-MM-dd']).toDate() // 兜底 存在parseDate在 text为'2024-01-01' 无法解析  format'yyyy-MM-dd HH:mm:ss',或类型错误时
  // }
  if (format === 'timestamp') return new Date(Number(text))

  const _format = MOMENT_FORMAT[format || 'YYYY-MM-DD']
  const strictFormats = Object.values(MOMENT_FORMAT)

  // 识别时间戳特征：纯数字，10位（秒）或13位（毫秒）
  if (/^\d+$/.test(text) && (String(text).length === 10 || String(text).length === 13)) {
    let num = Number(text)
    num = String(num).length === 10 ? num * 1000 : num
    return moment(moment(num).format(_format)).toDate()
  }

  const date = parseDate(text, format)

  const m = moment(text, strictFormats, true)
  // format='yyyy-MM-dd HH:mm:ss' text='2024-01-01'，parseDate无法解析，返回false
  if (!date && typeof text === 'string' && m.isValid()) {
    return moment(text, _format).toDate()
  }

  return date
}
const RANGE_FORMATTER = function (value, format) {
  if (Array.isArray(value)) {
    const start = value[0]
    const end = value[1]

    return [DATE_FORMATTER(start, format), DATE_FORMATTER(end, format)]
  }
  return ''
}
const SINGLE_RANGE_FORMATTER = function (value, format) {
  if (Array.isArray(value)) {
    return value.map(val => (isDate(val) ? DATE_FORMATTER(val, format) : !val ? '' : val))
  }
  return ''
}
const RANGE_PARSER = function (array, format, separator) {
  if (!Array.isArray(array)) {
    array = array.split(separator)
  }
  if (array.length === 2) {
    const range1 = array[0]
    const range2 = array[1]

    return [DATE_PARSER(range1, format), DATE_PARSER(range2, format)]
  }
  return []
}
const HOVER_FORMATTER = function (value, customFormat, type) {
  const formatter = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).formatter
  const format = customFormat || DEFAULT_FORMATS[type]
  let formattedValue = formatter(value, format)
  if (['week', 'weekrange'].includes(type)) {
    formattedValue = Array.isArray(value)
      ? value.map(date => tailWeekCheck(date, DEFAULT_FORMATS.week))
      : tailWeekCheck(value, DEFAULT_FORMATS.week)
  }
  return formattedValue
}

const TYPE_VALUE_RESOLVER_MAP = {
  default: {
    formatter(value) {
      if (!value) return ''
      return '' + value
    },
    parser(text) {
      if (text === undefined || text === '') return null
      return text
    }
  },
  week: {
    formatter(value, format) {
      if (!value) return ''
      let week = getWeekNumber(value)
      // let month = value.getMonth()
      const trueDate = new Date(value)
      //  // 这里的国际标准，不适应公司。比如选 2025-1月的第一周，实际给的日期时 2025-01-02，但UI显示的为2024-12-30为周一
      // if (week === 1 && month === 11) {
      // trueDate.setHours(0, 0, 0, 0)
      // trueDate.setDate(trueDate.getDate() + 3 - ((trueDate.getDay() + 6) % 7))
      // }
      let date = formatDate(trueDate, format)
      date = /WW/.test(date) ? date.replace(/WW/, week < 10 ? '0' + week : week) : date.replace(/W/, week)
      return date
    },
    // formatter(value, format) {
    //   let week = getWeekNumber(value)
    //   let month = value.getMonth()
    //   const trueDate = new Date(value)
    //   if (week === 1 && month === 11) {
    //     trueDate.setHours(0, 0, 0, 0)
    //     trueDate.setDate(trueDate.getDate() + 3 - ((trueDate.getDay() + 6) % 7))
    //   }
    //   let date = formatDate(trueDate, format)

    //   date = /WW/.test(date) ? date.replace(/WW/, week < 10 ? '0' + week : week) : date.replace(/W/, week)
    //   return date
    // },
    parser(text, format) {
      if (!text) return ''
      // parse as if a normal date
      return TYPE_VALUE_RESOLVER_MAP.date.parser(text, format)
    }
    // parser(text) {
    //   const array = (text || '').split('w')
    //   if (array.length === 2) {
    //     const year = Number(array[0])
    //     const month = Number(array[1])

    //     if (!isNaN(year) && !isNaN(month) && month < 54) {
    //       return text
    //     }
    //   }
    //   return null
    // }
  },
  date: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  datetime: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  daterange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  weekrange: {
    formatter(value, format) {
      return Array.isArray(value) ? value.map(date => TYPE_VALUE_RESOLVER_MAP.week.formatter(date, format)) : value
    },
    parser(text, format) {
      return Array.isArray(text)
        ? text.map(date => TYPE_VALUE_RESOLVER_MAP.date.parser(date, format))
        : TYPE_VALUE_RESOLVER_MAP.week.parser(text, format)
    }
  },
  monthrange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  datetimerange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  timerange: {
    formatter: RANGE_FORMATTER,
    parser: RANGE_PARSER
  },
  time: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  month: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  year: {
    formatter: DATE_FORMATTER,
    parser: DATE_PARSER
  },
  number: {
    formatter(value) {
      if (!value) return ''
      return '' + value
    },
    parser(text) {
      let result = Number(text)

      if (!isNaN(text)) {
        return result
      } else {
        return null
      }
    }
  },
  dates: {
    formatter(value, format) {
      return value.map(date => DATE_FORMATTER(date, format))
    },
    parser(value, format) {
      return (typeof value === 'string' ? value.split(', ') : value).map(date =>
        date instanceof Date ? date : DATE_PARSER(date, format)
      )
    }
  },
  months: {
    formatter(value, format) {
      return value.map(date => DATE_FORMATTER(date, format))
    },
    parser(value, format) {
      return (typeof value === 'string' ? value.split(', ') : value).map(date =>
        date instanceof Date ? date : DATE_PARSER(date, format)
      )
    }
  }
}
const PLACEMENT_MAP = {
  left: 'bottom-start',
  center: 'bottom',
  right: 'bottom-end'
}

const parseAsFormatAndType = (value, customFormat, type, rangeSeparator = '-') => {
  if (!value) return null
  const parser = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).parser
  const format = customFormat || DEFAULT_FORMATS[type]
  return parser(value, format, rangeSeparator)
}

const formatAsFormatAndType = (value, customFormat, type) => {
  if (!value) return null
  const formatter = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).formatter
  const format = customFormat || DEFAULT_FORMATS[type]
  return formatter(value, format)
}

/*
 * Considers:
 *   1. Date object
 *   2. date string
 *   3. array of 1 or 2
 */
const valueEquals = function (a, b) {
  // considers Date object and string
  const dateEquals = function (a, b) {
    const aIsDate = a instanceof Date
    const bIsDate = b instanceof Date
    if (aIsDate && bIsDate) {
      return a.getTime() === b.getTime()
    }
    if (!aIsDate && !bIsDate) {
      return a === b
    }
    return false
  }

  const aIsArray = a instanceof Array
  const bIsArray = b instanceof Array
  if (aIsArray && bIsArray) {
    if (a.length !== b.length) {
      return false
    }
    return a.every((item, index) => dateEquals(item, b[index]))
  }
  if (!aIsArray && !bIsArray) {
    return dateEquals(a, b)
  }
  return false
}

const isString = function (val) {
  return typeof val === 'string' || val instanceof String
}

const validator = function (val) {
  // either: String, Array of String, null / undefined
  return (
    val === null ||
    val === undefined ||
    isString(val) ||
    (Array.isArray(val) && val.length === 2 && val.every(isString))
  )
}

const FORMATMAP = {
  year: 'yyyy',
  month: 'yyyy-MM',
  months: 'yyyy-MM',
  date: 'yyyy-MM-dd',
  dates: 'yyyy-MM-dd',
  datetime: 'yyyy-MM-dd HH:mm',
  daterange: 'yyyy-MM-dd',
  datetimerange: 'yyyy-MM-dd HH:mm',
  time: 'HH:mm:ss',
  week: 'yyyywWW',
  timerange: 'HH:mm:ss',
  monthrange: 'yyyy-MM',
  years: 'yyyy'
}

export default {
  mixins: [Emitter, NewPopper],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    showLunar: {
      type: Boolean,
      default: true
    },
    size: String,
    format2: String,
    format: String,
    valueFormat: {
      type: String
      // default: 'yyyy-MM-dd HH:mm:ss'
    },
    readonly: Boolean,
    placeholder: String,
    startPlaceholder: String,
    endPlaceholder: String,
    prefixIcon: String,
    clearIcon: {
      type: String,
      default: 'el-icon-circle-close'
    },
    name: {
      default: '',
      validator
    },
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true
    },
    id: {
      default: '',
      validator
    },
    popperClass: String,
    editable: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'left'
    },
    value: {},
    defaultValue: {},
    defaultTime: {},
    // usePeDefaultTime: {
    //   type: Boolean,
    //   default: true
    // },
    rangeSeparator: {
      default: '~'
    },
    pickerOptions: {},
    // unlinkPanels: Boolean,
    cellPopperContent: [Function, String],
    leftCellPopperContent: [Function, String],
    rightCellPopperContent: [Function, String],
    inputTimeType: {
      type: String,
      default: 'min'
    },
    showWeekNumber: {
      type: Boolean,
      default: false
    },
    maxDate: {
      type: Date,
      default: () => new Date(`${new Date().getFullYear() + 70}-01-01 23:59:59`)
    },
    displayFormat: [Function, Array, String],
    // kye-date-picker在range的时候的参数也需要兼容
    leftDisabled: {
      // 左侧时间选择禁用
      type: Boolean,
      default: false
    },
    rightDisabled: {
      // 右侧时间选择禁用
      type: Boolean,
      default: false
    },
    // shortcutsCallback: {
    //   // 左侧面板回调，需返回一个数组
    //   type: Function,
    //   default: () => null
    // },
    // monthShortcutsCallback: {
    //   // 左侧选择月份面板回调，需返回一个数组
    //   type: Function,
    //   default: () => null
    // },
    // beforeShortcutsClick: Function,
    // clearBoth: {
    //   // 清除currentData
    //   type: Boolean,
    //   default: false
    // },
    showResetBtn: {
      // 是否展示"重置"按钮
      type: Boolean,
      default: true
    },
    singleValue: {
      // 保留单边的值，不清空整个currentData
      type: Boolean,
      default: false
    },
    // linkPanels: {
    //   // 联动面板，目前非singleValue的模式下，面板仅会展示开始时间的数据，开始结束时间都展示开始时间，增加配置显示对应的面板数据
    //   type: Boolean,
    //   default: false
    // },
    cellClassName: {
      type: [Function, String]
    },
    showShortcuts: {
      type: Boolean,
      default: true
    },
    operation: String,
    valueFormatter: Function,
    formatter: Function, // 原来kye-date-picker3的参数
    mode: {
      type: String,
      default: '' // [typeChange] 标记类型变化将使用内部type变化逻辑
    },
    transitionName: {
      type: String,
      default: 'el-zoom-in-top'
    }
  },

  directives: { Clickoutside },

  data() {
    return {
      pickerVisible: false,
      showClose: false,
      userInput: null,
      userHover: null,
      valueOnOpen: null, // value when picker opens, used to determine whether to emit change
      unwatchPickerOptions: null,
      activeInputIndex: 0,
      startInputBgVisible: false,
      endInputBgVisible: false,
      popoverTagWidth: 100
    }
  },

  watch: {
    pickerVisible(val) {
      if (this.readonly || this.pickerDisabled) return
      this.handlePickerVisible(val)
    },
    parsedValue: {
      immediate: true,
      handler(val) {
        if (this.picker) {
          this.picker.value = val
        }
      }
    },
    defaultValue(val) {
      // NOTE: should eventually move to jsx style picker + panel ?
      if (this.picker) {
        this.picker.defaultValue = val
      }
    },
    value(val, oldVal) {
      if (!valueEquals(val, oldVal) && !this.pickerVisible) {
        this.dispatch('ElFormItem', 'el.form.change', val)
      }
    },
    type() {
      if (this.mode === 'typeChange') {
        this.handleTypeChange()
      }
    }
  },

  computed: {
    currentValueFormat() {
      const defaultValueTime = () => {
        const useDefauleTime = ['week', 'date', 'datetime'].includes(this.$props.type)
        if (this.ranged || useDefauleTime) {
          return DEFAULT_FORMATS.datetime
        }
        return DEFAULT_FORMATS[this.$props.type]
      }
      let valueFormat = this.$attrs['value-format'] || this.$props.valueFormat || defaultValueTime()
      if (this.currentFormat === 'yyyy-MM') {
        valueFormat = this.currentFormat
      }
      return valueFormat
    },
    currentFormat() {
      // 自定义 format2 > format
      if (this.$props.format2) {
        return this.$props.format2
      }
      let format = this.$props.format ? this.$props.format.replace(':ss', '') : FORMATMAP[this.$props.type]
      return format
    },
    dateHasTime() {
      return ['datetime', 'datetimerange'].includes(this.$props.type)
    },
    ranged() {
      return this.type.indexOf('range') > -1
    },

    reference() {
      const reference = this.$refs.reference
      return reference.$el || reference
    },

    refInput() {
      if (this.reference) {
        return [].slice.call(this.reference.querySelectorAll('input'))
      }
      return []
    },

    valueIsEmpty() {
      const val = this.value
      if (Array.isArray(val)) {
        for (let i = 0, len = val.length; i < len; i++) {
          if (val[i]) {
            return false
          }
        }
      } else {
        if (val) {
          return false
        }
      }
      return true
    },

    triggerClass() {
      return this.prefixIcon || (this.type.indexOf('time') !== -1 ? 'layout layout-time' : 'el-icon-date')
    },

    selectionMode() {
      if (['week', 'weekrange'].includes(this.$props.type)) {
        return 'week'
      } else if (this.type === 'month') {
        return 'month'
      } else if (this.type === 'year') {
        return 'year'
      } else if (this.type === 'dates') {
        return 'dates'
      } else if (this.type === 'months') {
        return 'months'
      }

      return 'day'
    },

    haveTrigger() {
      // 单边时，去掉clear按钮，使用自身的。
      if (this.$props.singleValue) {
        return false
      }
      if (typeof this.showTrigger !== 'undefined') {
        return this.showTrigger
      }
      return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1
    },

    templateDisplayValue() {
      if (this.userHover) {
        return HOVER_FORMATTER(this.userHover, this.currentFormat, this.type)
      }
      if (this.$props.displayFormat) {
        if (typeof this.$props.displayFormat === 'function') {
          return this.$props.displayFormat({
            displayValue: this.displayValue,
            parsedValue: this.parsedValue
          })
        } else if (Array.isArray(this.$props.displayFormat)) {
          const [customStart, customEnd] = this.$props.displayFormat
          const [start, end] = this.displayValue
          return [customStart || start, customEnd || end]
        } else if (typeof this.$props.displayFormat === 'string') {
          return typeof this.$props.displayFormat
        }
      }
      if (this.$props.formatter && typeof this.$props.formatter === 'function') {
        return this.$props.formatter({
          displayValue: this.displayValue,
          parsedValue: this.parsedValue
        })
      }
      return this.displayValue
    },

    displayValue() {
      // 单边时，展示走自己的逻辑，单个需要展示，饿了么不行。必须展示完整区间
      if (this.$props.singleValue) {
        return SINGLE_RANGE_FORMATTER(this.parsedValue, this.currentFormat)
      }
      let formattedValue = formatAsFormatAndType(this.parsedValue, this.currentFormat, this.type, this.rangeSeparator)
      // 这里为了区分跨年周场景，value要拿周的第一天，格式化要拿下一年，比如2024-12-30是2025的第一周
      if (['week', 'weekrange'].includes(this.$props.type)) {
        formattedValue = Array.isArray(this.parsedValue)
          ? this.parsedValue.map(date => tailWeekCheck(date, DEFAULT_FORMATS.week))
          : tailWeekCheck(this.parsedValue, DEFAULT_FORMATS.week)
      }
      if (Array.isArray(this.userInput)) {
        return [
          this.userInput[0] || (formattedValue && formattedValue[0]) || '',
          this.userInput[1] || (formattedValue && formattedValue[1]) || ''
        ]
      } else if (this.userInput !== null) {
        return this.userInput
      } else if (formattedValue) {
        return this.type === 'dates' || this.type === 'months' ? formattedValue.join(', ') : formattedValue
      } else {
        return ''
      }
    },

    parsedValue() {
      if (!this.value) return this.value // component value is not set
      if (['time-select', 'monthrange'].includes(this.$props.type)) return this.value // time-select does not require parsing, this might change in next major version

      const valueIsDateObject =
        isDateObject(this.value) || (Array.isArray(this.value) && this.value.length && this.value.every(isDateObject))
      if (valueIsDateObject) {
        return this.value
      }

      const isWeek = ['week', 'weekrange'].includes(this.$props.type)
      const isDefaultValueFormat = this.currentValueFormat === DEFAULT_FORMATS.datetime
      if (this.currentValueFormat && !(isWeek && isDefaultValueFormat)) {
        // 单边时，走自己的解析逻辑
        if (this.$props.singleValue) {
          return SINGLE_RANGE_FORMATTER(this.value, this.currentValueFormat)
        }
        const val =
          parseAsFormatAndType(this.value, this.currentValueFormat, this.type, this.rangeSeparator) || this.value
        return val
      }

      // NOTE: deal with common but incorrect usage, should remove in next major version
      // user might provide string / timestamp without value-format, coerce them into date (or array of date)
      return Array.isArray(this.value) ? this.value.map(val => new Date(val)) : new Date(this.value)
    },

    _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize
    },

    pickerSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size
    },

    pickerDisabled() {
      return this.disabled || (this.elForm || {}).disabled
    },

    firstInputId() {
      const obj = {}
      let id
      if (this.ranged) {
        id = this.id && this.id[0]
      } else {
        id = this.id
      }
      if (id) obj.id = id
      return obj
    },

    secondInputId() {
      const obj = {}
      let id
      if (this.ranged) {
        id = this.id && this.id[1]
      }
      if (id) obj.id = id
      return obj
    },
    currentPlaceholder () {
      const map = {
        'date': '选择日期',
        'dates': '选择日期',
        'datetime': '选择日期时间',
        'daterange': ['开始日期', '结束日期'],
        'datetimerange': ['开始时间', '结束时间'],
        'week': '选择周',
        'weekrange': ['开始周', '结束周'],
        'month': '选择月份',
        'months': '选择月份',
        'monthrange': ['开始月份', '结束月份'],
        'year': '选择年份',
        'years': '选择年份',
      }
      // 多选月是盖上方实现的
      if (this.isMultiple && this.multipInputPrefixConfig.lastDate) {
        return ''
      }
      const val = map[this.$props.type]
      if (!this.ranged) {
        return this.$props.placeholder || val
      } else {
        return [this.$props.startPlaceholder || val[0], this.$props.endPlaceholder || val[1]]
      }
    },
    isMultiple() {
      return this.$props.type === 'months' || this.$props.type === 'dates'
    },
    multipInputPrefixConfig() {
      const data = String(this.displayValue)
        .split(',')
        .reduce((acc, val) => {
          const v = String(val).trim()
          if (v) {
            acc.push(val)
          }
          return acc
        }, [])
      const leng = data.length
      const lastIndex = leng - 1
      const lastDate = data[lastIndex]
      return {
        lastDate,
        leng,
        num: lastIndex,
        data
      }
    }
  },

  created() {
    // vue-popper
    this.popperOptions = {
      boundariesPadding: 0,
      gpuAcceleration: false
    }
    this.placement = PLACEMENT_MAP[this.align] || PLACEMENT_MAP.left

    this.$on('fieldReset', this.handleFieldReset)
  },

  methods: {
    handlePickerVisible(val) {
      if (val) {
        this.showPicker()
        this.valueOnOpen = Array.isArray(this.value) ? [...this.value] : this.value
      } else {
        this.changeInputBg(false)
        this.hidePicker()
        this.emitChange(this.value)
        this.userHover = null
        this.userInput = null
        this.daterangeHoverPicks = []
        this.dispatch('ElFormItem', 'el.form.blur')
        this.$emit('blur', this)
        this.blur()
      }
    },

    focus() {
      if (!this.ranged) {
        this.$refs.reference.focus()
      } else {
        this.handleFocus()
      }
    },

    blur() {
      this.refInput.forEach(input => input.blur())
    },

    // {parse, formatTo} Value deals maps component value with internal Date
    parseValue(value) {
      const isParsed = isDateObject(value) || (Array.isArray(value) && value.length && value.every(isDateObject))
      if (this.currentValueFormat && !isParsed) {
        return parseAsFormatAndType(value, this.currentValueFormat, this.type, this.rangeSeparator) || value
      } else {
        return value
      }
    },

    formatToValue(date) {
      const isFormattable = isDateObject(date) || (Array.isArray(date) && date.length && date.every(isDateObject))
      if (this.currentValueFormat && isFormattable) {
        return formatAsFormatAndType(date, this.currentValueFormat, this.type, this.rangeSeparator)
      } else {
        return date
      }
    },

    // {parse, formatTo} String deals with user input
    parseString(value) {
      const type = Array.isArray(value) ? this.type : this.type.replace('range', '')
      return parseAsFormatAndType(value, this.currentFormat, type)
    },

    formatToString(value) {
      const type = Array.isArray(value) ? this.type : this.type.replace('range', '')
      return formatAsFormatAndType(value, this.currentFormat, type)
    },

    handleMouseEnter() {
      // 单边时，不显示原有的清楚图标
      if (this.$props.singleValue) {
        return
      }
      if (this.readonly || this.pickerDisabled) return
      if (!this.valueIsEmpty && this.clearable) {
        this.showClose = true
      }
    },

    handleChange() {
      // 单边时，不走原有的逻辑
      if (this.$props.singleValue) {
        return
      }
      if (this.userInput) {
        const value = this.parseString(this.displayValue)
        if (value) {
          this.picker.value = value
          if (this.isValidValue(value, '输入的时间不可用')) {
            this.emitInput(value)
            this.userInput = null
          }
        }
      }
      if (this.userInput === '') {
        this.emitInput(null)
        this.emitChange(null)
        this.userInput = null
      }
    },

    handleStartInput(event) {
      // 单边时，不走原有的逻辑。
      if (this.$props.singleValue) {
        return
      }
      if (this.userInput) {
        this.userInput = [event.target.value, this.userInput[1]]
      } else {
        this.userInput = [event.target.value, null]
      }
    },

    handleEndInput(event) {
      // 单边时，不走原有的逻辑
      if (this.$props.singleValue) {
        return
      }
      if (this.userInput) {
        this.userInput = [this.userInput[0], event.target.value]
      } else {
        this.userInput = [null, event.target.value]
      }
    },

    handleStartChange(event) {
      // 单边时，仅改变开始时间
      if (this.$props.singleValue) {
        const value = this.parseString(event.target.value)
        const arr = this.parseSingleValueDate(value, 0)
        // 校验是否存在disableDate.存在且不通过，则不做处理
        if (
          this.isValidValue(
            arr.map(date => moment(date).toDate()),
            '输入的时间不可用'
          )
        ) {
          this.$emit('input', arr)
          return
        }
        return
      }
      const value = this.parseString(this.userInput && this.userInput[0])
      if (value) {
        this.userInput = [this.formatToString(value), this.displayValue[1]]
        const newValue = [value, this.picker.value && this.picker.value[1]]
        this.picker.value = newValue
        if (this.isValidValue(newValue, '输入的时间不可用')) {
          this.emitInput(newValue)
          this.userInput = null
        }
      }
    },

    handleEndChange(event) {
      // 单边时，仅改变结束时间
      if (this.$props.singleValue) {
        const value = this.parseString(event.target.value)
        const arr = this.parseSingleValueDate(value, 1)
        // 校验是否存在disableDate.存在且不通过，则不做处理
        if (
          this.isValidValue(
            arr.map(date => moment(date).toDate()),
            '输入的时间不可用'
          )
        ) {
          this.$emit('input', arr)
          return
        }
        return
      }
      const value = this.parseString(this.userInput && this.userInput[1])
      if (value) {
        this.userInput = [this.displayValue[0], this.formatToString(value)]
        const newValue = [this.picker.value && this.picker.value[0], value]
        this.picker.value = newValue
        if (this.isValidValue(newValue, '输入的时间不可用')) {
          this.emitInput(newValue)
          this.userInput = null
        }
      }
    },

    handleClickIcon(event) {
      if (this.readonly || this.pickerDisabled) return
      if (this.showClose) {
        this.valueOnOpen = this.value
        event.stopPropagation()
        this.emitInput(null)
        this.emitChange(null)
        this.showClose = false
        if (this.picker && typeof this.picker.handleClear === 'function') {
          this.picker.handleClear()
        }
        this.$emit('clear')
      } else {
        this.pickerVisible = !this.pickerVisible
      }
    },

    handleClose() {
      if (!this.pickerVisible) return
      this.pickerVisible = false

      if (this.type === 'dates' || this.type === 'months') {
        // restore to former value
        const oldValue =
          parseAsFormatAndType(this.valueOnOpen, this.currentValueFormat, this.type, this.rangeSeparator) ||
          this.valueOnOpen
        this.emitInput(oldValue)
      }
    },

    handleFieldReset(initialValue) {
      this.userInput = initialValue === '' ? null : initialValue
    },

    handleFocus(_, activeInputIndex) {
      const type = this.type
      let _value = this.userHover
      let singleValue = this.value || []
      const updateIndex = activeInputIndex === 0 ? 1 : 0
      const picker = this.picker
      const minDate = singleValue ? singleValue[0] : picker && picker.minDate
      const maxDate = singleValue ? singleValue[1] : picker && picker.minDate
      if (picker && _value && ((updateIndex === 0 && !minDate) || (updateIndex === 1 && !maxDate))) {
        _value[updateIndex] = ''
        this.userHover = [_value[0] || '', _value[1] || '']
      }
      this.activeInputIndex = activeInputIndex
      if (this.picker) {
        this.picker.activeInputIndex = activeInputIndex
      }
      this.changeInputBg()
      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
        this.pickerVisible = true
      }
      this.$emit('focus', this)
      // 单边时，focus打开时，展示当前的面板
      // if (this.$props.singleValue || this.$props.linkPanels) {
      //   this.$nextTick(() => {
      //     this.picker.showCurrentDatePanelData()
      //   })
      // }
    },

    handleKeydown(event) {
      const keyCode = event.keyCode

      // ESC
      if (keyCode === 27) {
        this.pickerVisible = false
        event.stopPropagation()
        return
      }

      // Tab
      if (keyCode === 9) {
        if (!this.ranged) {
          this.handleChange()
          this.pickerVisible = this.picker.visible = false
          this.blur()
          event.stopPropagation()
        } else {
          // user may change focus between two input
          setTimeout(() => {
            if (this.refInput.indexOf(document.activeElement) === -1) {
              this.pickerVisible = false
              this.blur()
              event.stopPropagation()
            }
          }, 0)
        }
        return
      }

      // Enter
      if (keyCode === 13) {
        if (this.userInput === '' || this.isValidValue(this.parseString(this.displayValue), '输入的时间不可用')) {
          this.handleChange()
          this.pickerVisible = this.picker.visible = false
          this.blur()
          this.$emit('input-enter', { value: this.displayValue })
        }
        event.stopPropagation()
        return
      }

      // if user is typing, do not let picker handle key input
      if (this.userInput) {
        event.stopPropagation()
        return
      }

      // delegate other keys to panel
      if (this.picker && this.picker.handleKeydown) {
        this.picker.handleKeydown(event)
      }
    },

    handleRangeClick() {
      // if (this.$props.singleValue) {
      //   // 单边的时候必须聚焦在输入框内才能唤醒
      //   return
      // }
      const type = this.type
      this.changeInputBg()

      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
        this.pickerVisible = true
      }
      this.$emit('focus', this)
    },

    hidePicker() {
      if (this.picker) {
        this.picker.resetView && this.picker.resetView()
        this.pickerVisible = this.picker.visible = false
        this.destroyPopper()
        this.picker.hiddDatePopper && this.picker.hiddDatePopper()
      }
    },

    showPicker() {
      if (this.$isServer) return
      if (!this.picker) {
        this.mountPicker()
      }
      this.pickerVisible = this.picker.visible = true

      this.updatePopper()
      this.picker.activeInputIndex = this.activeInputIndex

      this.picker.value = this.parsedValue
      this.picker.resetView && this.picker.resetView()
      this.picker.type = this.$props.type

      this.picker.cellClassName = this.$props.cellClassName
      this.picker.showShortcuts = this.$props.showShortcuts

      this.$nextTick(() => {
        this.picker.adjustSpinners && this.picker.adjustSpinners()
      })
    },

    mountPicker() {
      this.picker = new Vue(this.panel).$mount()
      this.picker.defaultValue = this.defaultValue
      this.picker.defaultTime = this.defaultTime
      // if (this.type === 'datetimerange' && !this.defaultTime && this.$props.usePeDefaultTime !== false) {
      if (this.type === 'datetimerange' && !this.defaultTime) {
        this.picker.defaultTime = ['00:00:00', '23:59:59']
      }
      this.picker.transitionName = ''
      this.picker.popperClass = this.popperClass
      this.popperElm = this.picker.$el
      this.picker.width = this.reference.getBoundingClientRect().width
      this.picker.showTime = this.type === 'datetime' || this.type === 'datetimerange'
      this.picker.selectionMode = this.selectionMode
      this.picker.unlinkPanels = this.unlinkPanels
      this.picker.arrowControl = this.arrowControl || this.timeArrowControl || false
      this.picker.handleDateMouseEnter = this.handleDateMouseEnter
      this.picker.handleDateMouseLeave = this.handleDateMouseLeave
      this.picker.type = this.$props.type
      this.picker.cellPopperContent =
        this.$props.cellPopperContent || this.$props.leftCellPopperContent || this.$props.rightCellPopperContent
      this.picker.leftCellPopperContent = this.$props.leftCellPopperContent
      this.picker.rightCellPopperContent = this.$props.rightCellPopperContent
      this.picker.inputTimeType = this.$props.inputTimeType
      this.picker.isWeekRange = this.$props.type === 'weekrange'
      this.picker.showWeekNumber = ['weekrange', 'week'].includes(this.$props.type) ? true : this.$props.showWeekNumber
      // // 展示“此刻”按钮：通过props.showNowOption传入，并赋值到子组件data数据来控制
      this.picker.showNowOption = this.showNowOption
      this.picker.showReset = this.showResetBtn
      // 显示农历，并赋值到子组件data数据来控制
      this.picker.showLunar = this.showLunar
      this.picker.clearable = this.clearable
      // this.picker.beforeShortcutsClick = this.beforeShortcutsClick
      // this.picker.shortcutsCallback = this.shortcutsCallback
      // this.picker.monthShortcutsCallback = this.monthShortcutsCallback
      this.picker.singleValue = this.$props.singleValue // 单边标识
      this.picker.linkPanels = this.$props.linkPanels // 联动标识
      this.picker.cellClassName = this.$props.cellClassName
      this.picker.showShortcuts = this.$props.showShortcuts
      this.picker.headerSlot = this.$scopedSlots.header || this.$slots.header
      this.$watch('format', format => {
        this.picker.format = this.currentFormat
      })

      const updateOptions = () => {
        const options = this.pickerOptions

        if (options && options.selectableRange) {
          let ranges = options.selectableRange
          const parser = TYPE_VALUE_RESOLVER_MAP.datetimerange.parser
          const format = DEFAULT_FORMATS.timerange

          ranges = Array.isArray(ranges) ? ranges : [ranges]
          this.picker.selectableRange = ranges.map(range => parser(range, format, this.rangeSeparator))
        }

        // 最大年份限制
        if (this.type !== 'weekrange') {
          this.picker.disabledDate = time => time.getTime() > this.$props.maxDate.getTime()
        }

        for (const option in options) {
          if (
            options.hasOwnProperty(option) &&
            // 忽略 time-picker 的该配置项
            option !== 'selectableRange'
          ) {
            this.picker[option] = options[option]
          }
        }

        // main format must prevail over undocumented pickerOptions.format
        if (this.currentFormat) {
          this.picker.format = this.currentFormat
        }
        // if (this.picker.createShortcuts) {
        //   this.picker.shortcuts = this.picker.createShortcuts()
        // }
      }
      updateOptions()
      this.unwatchPickerOptions = this.$watch('pickerOptions', () => updateOptions(), { deep: true })

      this.$el.appendChild(this.picker.$el)
      this.picker.resetView && this.picker.resetView()

      this.picker.$on('dodestroy', this.doDestroy)
      // 单边时，点击快捷面板处理相关数据
      this.picker.$on('single-value-short-pick', obj => {
        this.emitSingleValueInput(obj, true)
        this.pickerVisible = this.picker.visible = false
        this.picker.resetView && this.picker.resetView()
      })
      // 单边时，点击日期面板处理对应的数据
      this.picker.$on('single-value-pick', (obj, visible = false) => {
        this.userInput = null
        this.userHover = null
        this.daterangeHoverPicks = []
        this.pickerVisible = this.picker.visible = visible
        this.emitSingleValueInput({ ...obj, type: 'replace' }, false)
        this.picker.resetView && this.picker.resetView()
      })
      this.picker.$on('pick', (date = '', visible = false) => {
        this.userInput = null
        this.userHover = null
        this.daterangeHoverPicks = []
        this.pickerVisible = this.picker.visible = visible
        this.emitInput(date)
        this.picker.resetView && this.picker.resetView()
      })

      this.picker.$on('pick-hover', (date, updateIndex, foucsIndex) => {
        if ([0, 1].includes(foucsIndex)) {
          this.picker.activeInputIndex = this.activeInputIndex = foucsIndex
          this.changeInputBg()
        }
        let _value = this.userHover || []
        _value[updateIndex] = date
        this.userHover = [_value[0] || '', _value[1] || '']
      })

      this.picker.$on('datePicker', date => {
        this.$emit('datePicker', date)
      })

      this.picker.$on('select-range', (start, end, pos) => {
        if (this.refInput.length === 0) return
        if (!pos || pos === 'min') {
          this.refInput[0].setSelectionRange(start, end)
          this.refInput[0].focus()
        } else if (pos === 'max') {
          this.refInput[1].setSelectionRange(start, end)
          this.refInput[1].focus()
        }
      })

      this.picker.$on('reset', () => {
        this.valueOnOpen = null
        this.$emit('reset')
      })
    },

    unmountPicker() {
      if (this.picker) {
        this.picker.$destroy()
        this.picker.$off()
        if (typeof this.unwatchPickerOptions === 'function') {
          this.unwatchPickerOptions()
        }
        this.picker.$el.parentNode.removeChild(this.picker.$el)
      }
    },

    emitChange(val) {
      // determine user real change only
      if (!valueEquals(val, this.valueOnOpen)) {
        this.$emit('change', val)
        this.dispatch('ElFormItem', 'el.form.change', val)
        this.valueOnOpen = val
      }
    },

    // emitInput(val) {
    //   const formatted = this.formatToValue(val)
    //   if (!valueEquals(this.value, formatted)) {
    //     this.$emit('input', formatted)
    //   }
    // },
    parseSingleValueDate(value, activeInputIndex, type) {
      let arr
      // 直接替换
      if (type === 'replace') {
        arr = Array.isArray(value) ? [...value] : value
      } else {
        // 根据激活输入框，填充自己的数据
        if (Array.isArray(this.value)) {
          arr = [...this.value]
        } else {
          arr = ['', '']
        }
        // 存在数据, 才赋值
        if (arr[activeInputIndex] || value) {
          arr[activeInputIndex] = value
        }
      }
      // 纠正
      if (arr.filter(Boolean).length === 2) {
        arr = correctDatesOrder(arr)
      }
      if (this.currentValueFormat) {
        arr = SINGLE_RANGE_FORMATTER(arr, this.currentValueFormat)
      }
      arr = dateFormatCallback(arr, this)
      if (this.$props.valueFormatter && typeof this.$props.valueFormatter === 'function') {
        arr = this.$props.valueFormatter(value, arr)
      }
      return arr
    },
    // 单边时，向外抛出对应的数据
    emitSingleValueInput({ value, activeInputIndex, type }) {
      const arr = this.parseSingleValueDate(value, activeInputIndex, type)
      this.$emit('input', arr)
      return arr
    },
    emitInput(val) {
      const formatted = this.formatToValue(val)
      if (!valueEquals(this.value, formatted)) {
        // console.log(99, dateFormatCallback(formatted, this))
        let value = dateFormatCallback(formatted, this)
        if (this.$props.valueFormatter && typeof this.$props.valueFormatter === 'function') {
          value = this.$props.valueFormatter(val, value)
        }
        this.$emit('input', value)
      }
    },

    isValidValue(value, msg = '选择的时间不可用') {
      if (!this.picker) {
        this.mountPicker()
      }
      if (this.picker.isValidValue) {
        return value && this.picker.isValidValue(value, msg)
      } else {
        return true
      }
    },

    handleDateMouseEnter(params) {
      // isDateRangePick 当前是否在范围选择中
      const { isDateRangePick, newDate } = params
      const singleValue = this.$props.singleValue
      const curAcitveIndex = this.activeInputIndex
      const currentVal = this.picker.value
      const minDate = this.picker.minDate
      const maxDate = this.picker.maxDate
      const isHover = isDateRangePick === undefined
      const isRangeSelected = this.ranged && minDate && maxDate
      const isTimeRange = this.$props.type === 'datetimerange'
      let _newDate = newDate
      let _value = this.userHover || []

      if (!this.daterangeHoverPicks) {
        this.daterangeHoverPicks = []
      }

      if (this.ranged && currentVal && currentVal.length === 2) {
        if (!this.daterangeHoverPicks.length) {
          const [start, end] = (Array.isArray(currentVal) && currentVal) || []
          if (start) _value[0] = start
          if (end) _value[1] = end
        }
        if (isDateRangePick === false && _value.length === 2 && _value.every(Boolean) && new Date(_newDate).getTime() > new Date(currentVal[1]).getTime()) {
          _value[1] = ''
        }
      }


      // 已选后不更新
      if (!this.ranged && currentVal) {
        return
      }

      if (singleValue && isHover && currentVal[curAcitveIndex]) {
        return
      }

      // 时间区间类型，点击的时候走内部事件触发hover更新
      if (isTimeRange && isHover) {
        if ((curAcitveIndex === 1 && !maxDate) || (curAcitveIndex === 0 && !minDate)) {
            _value[curAcitveIndex] = _newDate
        }
        this.userHover = [_value[0] || '', _value[1] || '']
        return
      }

      if (isRangeSelected) {
        // 已选后改变单个值重新触发聚焦
        if (isDateRangePick === false && curAcitveIndex === 0 && !isTimeRange) {
          this.picker.activeInputIndex = this.activeInputIndex = 1
          // 增加的输入框的bg切换
          this.changeInputBg()
        }
        return
      }

      // 从结束时间开始，会存在稀疏数组
      if (Object.keys(this.daterangeHoverPicks).length === 2) {
        if (!isHover) {
          _value[curAcitveIndex] = _newDate
          this.userHover = [_value[0] || '', _value[1] || '']
        }
        return
      }

      if (isDateRangePick) {
        // if (currentVal && currentVal.length === 2 && currentVal.every(Boolean) && !this.daterangeHoverPicks.length) {
        //   // _value = ['', '']
        //   _value[curAcitveIndex] = val.minDate || val.maxDate
        // }
        // 根据激活的输入框，来设置对应的hover值
        if (!isTimeRange) {
          this.picker.activeInputIndex = this.activeInputIndex = curAcitveIndex === 0 ? 1 : 0
        }
      }
      // 记录用户已点击选择了某个输入框
      if (!isHover) {
        this.daterangeHoverPicks[curAcitveIndex] = isDateRangePick
      }

      // 增加的输入框的bg切换
      this.changeInputBg()

      // 是否是区间
      if (this.ranged) {
        if (!isDateRangePick) {
          _value[curAcitveIndex] = _newDate
        }
        if (this.$props.singleValue && isDateRangePick) {
          _value[curAcitveIndex] = _newDate
        }
        this.userHover = [_value[0] || '', _value[1] || '']
      } else {
        this.userHover = _newDate
      }
    },

    handleDateMouseLeave() {},

    emitCreateValue() {
      this.$nextTick(() => {
        const formatted = this.formatToValue(this.value)
        if (!valueEquals(this.value, formatted)) {
          let value = dateFormatCallback(formatted, this)
          if (this.$props.valueFormatter && typeof this.$props.valueFormatter === 'function') {
            value = this.$props.valueFormatter(value, this.value)
          }
          this.$emit('input', value)
        }
        // 对齐 kye-date-picker中处理默认值的格式化问题
        if (!this.ranged) {
          if (
            this.value &&
            (typeof this.value !== 'string' ||
              (typeof this.value === 'string' && this.value.length !== this.currentValueFormat.length))
          ) {
            let newVal = FORMAT(this.value, this.currentValueFormat)
            this.$emit('input', newVal)
          }
        }
      })
    },
    handleDeleteDates() {
      if (this.$props.readonly || this.pickerDisabled) return
      // 删除逻辑
      const value = this.value.slice(0, this.value.length - 1)
      if (this.picker) {
        this.picker.value = this.parsedValue
        this.picker.visible = false
      }
      this.emitInput(value || null)
      this.emitChange(value || null)
      this.userInput = null
      this.pickerVisible = false
    },
    handleMouseEnterMultipleTag(e) {
      if (this.pickerVisible || !this.multipInputPrefixConfig.leng) {
        return
      }
      const reference = this.$refs.reference.$el
      this.$refs.multiplePopover.referenceElm = reference
      this.$refs.multiplePopover.createPopper()
      this.$refs.multiplePopover.showPopper = true
      this.popoverTagWidth = reference.offsetWidth
      this.$nextTick(() => {
        this.$refs.multiplePopover.$refs.popper.style.zIndex = PopupManager.nextZIndex()
      })
    },
    handleMouseLeaveMultipleTag() {
      if (this.$refs.multiplePopover) {
        this.$refs.multiplePopover.showPopper = false
      }
    },
    // 用于切换类型更换popover目标元素
    getReferenceEl() {
      const reference = this.$refs.reference
      return reference.$el || reference
    },
    handleTypeChange() {
      this.$nextTick(() => {
        this.doDestroy && this.doDestroy()
        this.picker = null
        this.referenceElm = this.getReferenceEl()
        if (this.pickerVisible) {
          this.handlePickerVisible(true)
        }
        // 箭头需要重新创建并更新
        if (this.referenceElm.__vue__) {
          this.referenceElm.__vue__.appended = false
          this.referenceElm.__vue__.appendArrow(this.picker.$el)
          this.referenceElm.__vue__.updatePopper()
        }
      })
    },
    changeInputBg (val) {
      const showLeftBg = val !== undefined ? val : this.activeInputIndex === 0
      const showRightBg = val !== undefined ? val : this.activeInputIndex === 1

      this.startInputBgVisible = showLeftBg
      this.endInputBgVisible = showRightBg
    }
  },
  mounted() {
    // 对齐 kye-date-picker初始化的时候会触发一次
    this.emitCreateValue()
  }
}
</script>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker3/src/picker.vue